module.exports = __webpack_public_path__ + "media/images/baner-dec-left-b86181328d6a9aca42fe10e19e563844.png";